import { Service } from "@/api";

export function getWebsitePhoto(data) {
    return Service({
        url: 'api/officalWebsitePhoto',
        data
    })
}

export default { getWebsitePhoto }